import { Link } from "gatsby";
import React from "react";

export const BtnPrimary = ({ btnText, link }) => {
  return (
    <Link to={link} target="_blank">
      <button type="button" className="btn btn-primary">
        {btnText}
      </button>
    </Link>
  );
};




